export default "__VITE_ASSET__$ZN0TDfe__"